var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.225 8-2.365 8.247a28.837 28.837 0 0 0-.74 3.284v.016h-.072c-.064-.616-.231-1.233-.335-1.757l-2.604-9.79h-5.328l-2.589 9.781c-.103.525-.27 1.142-.334 1.758h-.073v-.015a28.842 28.842 0 0 0-.74-3.284L8.689 8H4.914l1.107 3.877H2v2.775h4.81l.788 2.76H2v2.782h6.387l1.266 4.447h4.507l3.05-11.66c.096-.432.184-.903.208-1.234h.071c.023.324.11.801.206 1.233l3.05 11.66h4.508L30 8h-3.775z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWxt);
export default __webpack_public_path__ + "static/media/WXT.d074e252b65380f225a57c748740fc2c.svg";
export { ForwardRef as ReactComponent };